import axios from '@/utils/axios';
import router from '@/router/index';
import { fetchUserPermissions } from './../../../services/auth/permission';

export default {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || null,
        logoutMessage: null,
        loggedInUser: null,
        modules: null,
        authorization: null,
        authorizations: null,
        permissions: []
    },
    mutations: {
        setToken(state, payload) {
            state.token = payload;
        },
        clearToken(state) {
            state.token = null;
        },
        clearLogoutMessage(state) {
            state.logoutMessage = null
        },
        setLogoutMessage(state, payload) {
            state.logoutMessage = payload;
        },
        setLoggedInUser(state,payload) {
            state.loggedInUser = payload;
        },
        setModules(state, payload) {
            state.modules = payload; 
        },
        setAuthorizations(state, payload) {
            state.authorizations = payload;
        },
        setPermissions(state, payload) {
            state.permissions = payload;
        }
    },
    getters: {
        loggedIn(state) {
            return !!state.token;
        },
        user_id(state) {
            return state.loggedInUser.id;
        },
        hasPermission: state => permission => {
            return state.permissions.includes(permission)
        }
    },
    actions: {
        login({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'post',
                    url: `auth/login`,
                    data: payload
                })
                .then((response) => {
                    resolve(response);
                    localStorage.setItem('token', response.data.token);
                    commit('setToken', response.data.token);
                    commit('setLoggedInUser', response.data.user);
                    commit('clearLogoutMessage');
                })
                .catch((error) => {
                    reject(error);
                })
            })
        },
        getCurrentUser({commit, state, dispatch}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'get',
                    url: `auth/current-user`,
                    headers: {Authorization: `Bearer ${state.token}`}
                })
                .then((response) => {
                    resolve(response);
                    commit('setLoggedInUser', response.data);
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        logout({commit}, payload) {
            localStorage.removeItem('token');
            commit('clearToken');
            commit('setLogoutMessage', payload.message);
            router.push('/auth/login');
        },
        fetchModules({commit, state, dispatch}){
            return new Promise((resolve, reject) => { 
                axios.request({
                    method: 'get',
                    url: `auth/modules`,
                    headers: {Authorization: `Bearer ${state.token}`},
                })
                .then((response) => {
                    commit('setModules', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        fetchAuthorizations({commit, state, dispatch}, payload) {
            return new Promise((resolve, reject) => { 
                axios.request({
                    method: 'get',
                    url: `auth/${payload}`,
                    headers: {Authorization: `Bearer ${state.token}`},
                })
                .then((response) => {
                    commit('setAuthorizations', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        fetchPermissions({commit, dispatch}) {
            fetchUserPermissions().then(resp => {
                commit("setPermissions", resp.data)
            }).catch(() => {
                dispatch('authentication/logout',{ message: 'Failed getting user permissions' }, {root: true})
            });

        }
    }
}